import { Handle, Position } from "reactflow";
import { mdiCallSplit } from "@mdi/js";
import Icon from "@mdi/react";
import NoteTooltip from "../misc/NoteTooltip";

export default function DecisionNode({ data }) {
  return (
    <div>
      <div className="DecisionNodeFake">
        <div className="DecisionNode"></div>

        <div className="DecisionNodeIcon">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ marginTop: "5px" }}>
              {data.advanced.note ? (
                <NoteTooltip title={data.advanced.note}></NoteTooltip>
              ) : (
                <></>
              )}
            </div>
            <div>
              <Icon
                path={mdiCallSplit}
                size={1}
                color="white"
                rotate={90}
              ></Icon>
            </div>
          </div>
        </div>

        <Handle
          className="DecisionTopHandle"
          type="target"
          position={Position.Top}
          isConnectable={false}
        />
        <Handle
          className="DecisionBottomHandle"
          type="source"
          position={Position.Bottom}
          id="a"
          isConnectable={false}
        />
      </div>
    </div>
  );
}
